module.exports = __webpack_public_path__ + "media/images/subarena_v4-974aacc5ec4f2c2a32f3859677bb8e1c.png";